import { t } from 'i18next';
import { ChevronDownSmall } from '@peacecover/icon';

interface NewPostLoadButtonProps {
  onClick: () => void;
}

const NewPostLoadButton = ({ onClick }: NewPostLoadButtonProps) => {
  return (
    <button
      type="button"
      className="w-fit mb-[57px] mx-auto flex items-center gap-[6px] border-[1.5px] border-pure-white bg-black-opacity-600 dark:bg-white-opacity-600 py-[8px] pl-[14px] pr-[16px] rounded-[20px]"
      onClick={onClick}
    >
      <ChevronDownSmall size={14} className="text-pure-white" />
      <p className="text-[14px] font-semibold text-pure-white leading-[17px]">
        {t('LoungeChatPage.loadNewPost')}
      </p>
    </button>
  );
};

export default NewPostLoadButton;
